import React, { useEffect, useMemo, useState, useContext, useCallback, useRef } from "react";
import "../../assets/custom/css/cti.css";
import NavBar from "./NavBar";
import ConferenceScreen from "./screens/ConferenceScreen";
import DispositionScreen from "./screens/DispositionScreen";
import IdleScreen from "./screens/IdleScreen";
import OnCallScreen from "./screens/OnCallScreen";
import RingingScreen from "./screens/RingingScreen";
import hangupAudio from "./screens/hangup-audio.mp3";
import Header from "../../components/partials/dashboard/HeaderStyle/header";
import { Modal } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Button } from "primereact/button";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { API_AGENT_DASHBOARD_CAMPAIGNS } from "../../service/url";
import { USER_ROLES } from '../../utilities/constant';
import { postApiCall, getApiCall } from "../../service/httpCall";
import { getIdleSeconds } from "./ctiHelpers";
import {
  API_BREAK_LIST,
  USER_BREAKS_EDIT,
  USER_BREAKS_CREATE,
  API_AGENT_DASHBOARD_CALLS,
  API_AGENT_IDLE_STATS,
  API_AGENT_ANNOUNCEMENT_LIST,
  API_CALLS_CREATE,
  API_VOICE_CAMPAIGNS_GET_ONE,
  API_DISPOSITION_FORM_DATA_CREATE,
  API_REMARK_STATUS_LIST,
  API_CALL_CENTER_UPDATE_CHANNEL_LICENCE,
} from "../../service/url";
import { toast } from "react-toastify";
import { BreakContext } from "../../router/context/BreakContext";
import { useCallStore } from "../../router/zustand/callStore";

const durationToSeconds = (duration) => {
  const minutes = parseInt(duration, 10);
  return minutes * 60;
};

function CTI() {
  const [showBreakModal, setShowBreakModal] = useState(false);
  const [userId, setUserId] = useState(null);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [isRefreshingCredits, setIsRefreshingCredits] = useState(false);
  const handleShow = () => setShowBreakModal(true);
  const handleClose = () => setShowBreakModal(false);
  // const [screen, setScreen] = useState("idle");
  const [theme, setTheme] = useState(
    () => localStorage.getItem("theme") || "light",
  );
  const [activeTab, setActiveTab] = useState("log");
  const [dialNum, setDialNum] = useState("");
  const dialNumRef = useRef(dialNum);
  const dialerLockedPrefixRef = useRef("");
  const dialerPrevValueRef = useRef("");
  const [holdOn, setHoldOn] = useState(false);
  const [muteOn, setMuteOn] = useState(false);
  const [idleStatus, setIdleStatus] = useState("READY");
  const [idleSeconds, setIdleSeconds] = useState(0);
  const [callSeconds, setCallSeconds] = useState(272);
  const [confSeconds, setConfSeconds] = useState(728);
  const [breaksData, setBreaksData] = useState([]);
  const [userData, setUserData] = useState(null);
  const { breakEndTime, userStatus, startBreak, stopBreak, setSelectedBreakId, selectedBreakId, countdown} = useContext(BreakContext);

  const [loggedUserRole, setLoggedUserRole] = useState(null);
  const [loggedUserId, setLoggedUserId] = useState(null);
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [agentCallsData, setAgentCallsData] = useState([]);
  const [announcements, setAnnouncements] = useState([]);
  // const [webrtcStatus, setWebrtcStatus] = useState(null);
  const [idleStartedAt, setIdleStartedAt] = useState(() => new Date().toISOString());
  const [manualScreen, setManualScreen] = useState(null);
  const [telephonyProfileActive, setTelephonyProfileActive] = useState(false)

  const webrtcStatus = useCallStore((state) => state.webrtcPhoneStatus);
  const webrtcIdleTime = useCallStore((state) => state.webrtcPhoneStartTime);
  const idleSessionStartedAt = useCallStore((state) => state.idleSessionStartedAt);
  const session = useCallStore((state) => state.session);
  const callerNumber = useCallStore((state) => state.callerNumber);
  const sipCampaignId = useCallStore((state) => state.sipCampaignId);
  const sipLeadData = useCallStore((state) => state.sipLeadData);

  const hangupAudioRef = useRef(null);

  useEffect(() => {
    dialNumRef.current = dialNum;
  }, [dialNum]);

  useEffect(() => {
  const unlockAudio = () => {
    const audio = hangupAudioRef.current;
    if (!audio) return;

    audio.play()
      .then(() => {
        audio.pause();
        audio.currentTime = 0;
        console.log("Audio unlocked for future playback");
      })
      .catch(() => {});

    document.removeEventListener("click", unlockAudio);
    document.removeEventListener("touchstart", unlockAudio); // add for mobile
  };

  document.addEventListener("click", unlockAudio, { once: true });
  document.addEventListener("touchstart", unlockAudio, { once: true });

  return () => {
    document.removeEventListener("click", unlockAudio);
    document.removeEventListener("touchstart", unlockAudio);
  };
}, []);

useEffect(() => {
    // Keep a simple break flag in the call store so SIP bindings can auto-decline calls during break.
    useCallStore.getState().setOnBreak(userStatus === "BREAK");
  }, [userStatus]);

  useEffect(() => {
  const audio = hangupAudioRef.current;
  if (audio) {
    console.log("Audio element loaded:", {
      src: audio.src,
      readyState: audio.readyState,
      duration: audio.duration,
      networkState: audio.networkState
    });
  }
}, []);

  // const attachRemoteAudioFromSession = useCallback((activeSession) => {
  //   try {
  //     const audioElement = document.getElementById("remoteAudio");
  //     if (!audioElement) return;

  //     // If SIP.js already attached remote media, don't replace it (replacing `srcObject`
  //     // can interrupt an in-flight `play()` call and trigger "new load request" errors).
  //     if (audioElement.srcObject) {
  //       const playPromise = audioElement.play?.();
  //       if (playPromise && typeof playPromise.catch === "function") {
  //         playPromise.catch((e) => console.log("Remote audio play error:", e));
  //       }
  //       return;
  //     }

  //     const handler = activeSession?.sessionDescriptionHandler;
  //     const peerConnection = handler?.peerConnection || handler?._peerConnection;
  //     if (!peerConnection || typeof peerConnection.getReceivers !== "function") return;

  //     const receivers = peerConnection.getReceivers();
  //     console.log("Receivers -------------------->:", receivers);
  //     receivers.forEach(r => console.log("Track:", r.track));

  //     const remoteStream = new MediaStream();
  //     peerConnection.getReceivers().forEach((receiver) => {
  //       if (receiver?.track) remoteStream.addTrack(receiver.track);
  //     });

  //     if (remoteStream.getTracks().length === 0) return;

  //     audioElement.autoplay = true;
  //     audioElement.playsInline = true;
  //     audioElement.muted = false;
  //     audioElement.volume = 1;

  //     const onLoadedMetadata = () => {
  //       audioElement.removeEventListener("loadedmetadata", onLoadedMetadata);
  //       const playPromise = audioElement.play?.();
  //       if (playPromise && typeof playPromise.catch === "function") {
  //         playPromise.catch((e) => console.log("Remote audio play error:", e));
  //       }
  //     };

  //     audioElement.addEventListener("loadedmetadata", onLoadedMetadata);
  //     audioElement.srcObject = remoteStream;
  //   } catch (e) {
  //     console.error("Failed to attach remote audio:", e);
  //   }
  // }, []);

  // useEffect(() => {
  //   if (!session) return;
  //   if (!session.stateChange?.addListener) return;

  //   const onStateChange = (state) => {
  //     if (state === "Established") {
  //       // Try to play whatever SIP.js attached (if any) without replacing media.
  //       try {
  //         const audioElement = document.getElementById("remoteAudio");
  //         const playPromise = audioElement?.play?.();
  //         if (playPromise && typeof playPromise.catch === "function") {
  //           playPromise.catch((e) => console.log("Remote audio play error:", e));
  //         }
  //       } catch {
  //         // ignore
  //       }

  //       // Non-invasive fallback: if SIP.js fails to attach/play remote audio,
  //       // attach from peer connection once Established.
  //       setTimeout(() => attachRemoteAudioFromSession(session), 300);
  //     }

  //     if (state === "Terminated") {
  //       const audioElement = document.getElementById("remoteAudio");
  //       if (audioElement) {
  //         try {
  //           audioElement.pause?.();
  //         } catch {
  //           // ignore
  //         }
  //         audioElement.srcObject = null;
  //       }
  //     }
  //   };

  //   try {
  //     session.stateChange.addListener(onStateChange);
  //   } catch (e) {
  //     console.error("Failed to listen for session state changes:", e);
  //   }

  //   if (session.state === "Established") {
  //     attachRemoteAudioFromSession(session);
  //   }

  //   return () => {
  //     try {
  //       session.stateChange?.removeListener?.(onStateChange);
  //     } catch {
  //       // ignore
  //     }
  //   };
  // }, [attachRemoteAudioFromSession, session]);

  const parsedStatus = useMemo(() => {
    if (!webrtcStatus) {
      return {
        success: false,
        code: "DISCONNECTED",
        message: "Dialer is Disconnected",
      };
    }
  
    const status = webrtcStatus.toLowerCase();
  
    // ✅ SUCCESS CASE (only 200 / connected)
    if (status === "connected") {
      return {
        success: true,
        code: "READY",
        message: "Dialer connected",
      };
    }
  
    // ✅ AUTHENTICATING (401 first case)
    if (status.includes("authenticating")) {
      return {
        success: false,
        code: "AUTH",
        message: "Authenticating...",
      };
    }
  
    // ✅ GENERIC "code - message" fallback
    const match = webrtcStatus.match(/^(\d+)\s*-\s*(.*)$/);
  
    if (match) {
      return {
        success: false,
        code: match[1],
        message: match[2],
      };
    }
  
    // ✅ FALLBACK (plain message)
    return {
      success: false,
      code: "ERROR",
      message: webrtcStatus,
    };
  }, [webrtcStatus]);

  const callState = useCallStore((state) => state.callState);
  const completedCallToPersist = useCallStore((state) => state.completedCallToPersist);

  const [activeCampaignFromSip, setActiveCampaignFromSip] = useState(null);
  const [activeCampaignLoading, setActiveCampaignLoading] = useState(false);

  const [dispositionSubmitting, setDispositionSubmitting] = useState(false);
  const [dispositionErrors, setDispositionErrors] = useState({});
  const [dispositionValues, setDispositionValues] = useState({});
  const [dispositionMeta, setDispositionMeta] = useState(null);
  const [dispositionOpenedForCallSid, setDispositionOpenedForCallSid] = useState(null);
  const [remarkStatusList, setRemarkStatusList] = useState([]);
  const [remarkStatusLoading, setRemarkStatusLoading] = useState(false);

  useEffect(() => {
    // Force ringing UI when a new incoming call arrives.
    if (callState === "incoming") setManualScreen(null);
    // Reset manual navigation when call ends.
    if (callState === "idle") setManualScreen(null);
  }, [callState]);

  useEffect(() => {
    // While on-call, prefill the dialer with the caller number and lock it as a non-deletable prefix.
    const callActive =
      callState === "oncall" ||
      callState === "connected" ||
      callState === "hold" ||
      callState === "conference";

    if (callActive && callerNumber) {
      if (!dialerLockedPrefixRef.current) {
        dialerPrevValueRef.current = dialNumRef.current || "";
        dialerLockedPrefixRef.current = callerNumber;
        setDialNum(callerNumber);
      }
      return;
    }

    if (callState === "idle" && dialerLockedPrefixRef.current) {
      dialerLockedPrefixRef.current = "";
      setDialNum(dialerPrevValueRef.current || "");
      dialerPrevValueRef.current = "";
    }
  }, [callState, callerNumber]);

  const normalizeSipHeaders = useCallback((req) => {
    if (!req) return {};
    const raw = req.headers || {};
    const normalized = {};

    Object.keys(raw).forEach((key) => {
      const lower = String(key || "").toLowerCase();
      let value = null;
      try {
        value = req.getHeader(key);
      } catch {
        value = null;
      }

      if (!value) {
        const arr = raw[key];
        if (Array.isArray(arr) && arr[0]?.raw) value = String(arr[0].raw);
      }

      if (typeof value === "string") value = value.trim();
      if (value) normalized[lower] = value;
    });

    return normalized;
  }, []);

  const getHeaderValue = useCallback((headers, names) => {
    if (!headers) return null;
    const keys = Array.isArray(names) ? names : [names];
    for (const name of keys) {
      const key = String(name || "").toLowerCase();
      const val = headers[key];
      if (val !== undefined && val !== null && String(val).trim() !== "") {
        return String(val).trim();
      }
    }
    return null;
  }, []);

  const tryParseJson = (value) => {
    if (!value || typeof value !== "string") return null;
    const trimmed = value.trim();
    if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) return null;
    try {
      return JSON.parse(trimmed);
    } catch {
      return null;
    }
  };

  useEffect(() => {
    if (!session?.request) return;

    const headers = normalizeSipHeaders(session.request);

    const campaignIdFromHeader = getHeaderValue(headers, [
      "campaign_id",
      "x-campaign-id",
      "x-campaign_id",
      "campaign-id",
    ]);

    const leadJson =
      getHeaderValue(headers, ["x-lead-data", "x-lead", "lead-data", "caller_profile"]) ||
      null;
    const parsedLeadJson = tryParseJson(leadJson);

    const leadData = {
      first_name:
        parsedLeadJson?.first_name ||
        getHeaderValue(headers, ["first_name", "x-first-name", "x-first_name"]) ||
        null,
      last_name:
        parsedLeadJson?.last_name ||
        getHeaderValue(headers, ["last_name", "x-last-name", "x-last_name"]) ||
        null,
      company:
        parsedLeadJson?.company ||
        getHeaderValue(headers, ["company", "x-company", "x-company-name", "x-company_name"]) ||
        null,
      contact_number: callerNumber || null,
    };

    useCallStore.getState().setSipData({
      sipHeaders: headers,
      sipCampaignId: campaignIdFromHeader || null,
      sipLeadData: leadData,
    });

    const profileName = [leadData.first_name, leadData.last_name].filter(Boolean).join(" ").trim();
    if (profileName) {
      useCallStore.getState().updateActiveCallMeta({ caller_profile: profileName });
    }
  }, [callerNumber, getHeaderValue, normalizeSipHeaders, session]);

  const fetchRemarksStatusList = async () => {
    setRemarkStatusLoading(true);
    try {
      const res = await getApiCall(API_REMARK_STATUS_LIST, {});
      const list = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
      const activeRemarks = list.filter((item) => item.status === "Active" && !item.is_deleted);
      setRemarkStatusList(activeRemarks);
    } catch (error) {
      console.log("Error fetching remarks status list", error);
    } finally {
      setRemarkStatusLoading(false);
    }
  }

  useEffect(() => {
    fetchRemarksStatusList();
  }, []);

  useEffect(() => {
    const campaignId = sipCampaignId;
    if (!campaignId) {
      setActiveCampaignFromSip(null);
      return;
    }

    let mounted = true;
    setActiveCampaignLoading(true);

    const url = API_VOICE_CAMPAIGNS_GET_ONE.replace(":id", campaignId);
    getApiCall(url, {}, false)
      .then((resp) => {
        if (!mounted) return;
        setActiveCampaignFromSip(resp || null);
      })
      .catch((err) => {
        console.error("Failed to load campaign by campaign_id from SIP headers", err);
        if (mounted) setActiveCampaignFromSip(null);
      })
      .finally(() => {
        if (mounted) setActiveCampaignLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [sipCampaignId]);

  const screen = useMemo(() => {
    if (manualScreen) return manualScreen;

    switch (callState) {
      case "incoming":
        return "ringing";
      case "oncall":
        return "oncall";
      case "conference":
        return "conference";
      default:
        return "idle";
    }
  }, [callState, manualScreen]);

  useEffect(() => {
    const interval = setInterval(() => {
      const storedTheme = localStorage.getItem("theme") || "light";

      setTheme((prev) => {
        if (prev !== storedTheme) {
          const isDark = storedTheme === "dark";

          document.documentElement.classList.toggle("dark", isDark);
          document.body.classList.toggle("dark", isDark);

          return storedTheme;
        }
        return prev;
      });
    }, 250);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      if (screen === "oncall") setCallSeconds((value) => value + 1);
      if (screen === "conference") setConfSeconds((value) => value + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [screen]);

  useEffect(() => {
    if (screen === "idle" && parsedStatus?.success) {
      setIdleStartedAt(new Date().toISOString());
      // setIdleSeconds(0);
    }
  }, [screen, parsedStatus]);

  useEffect(() => {
    if (!parsedStatus?.success) {
      setIdleSeconds(0);
      return;
    }

    if (screen !== "idle") {
      setIdleSeconds(0);
      return;
    }

    const startAt = idleSessionStartedAt || webrtcIdleTime;
    if (!startAt) {
      setIdleSeconds(0);
      return;
    }

    setIdleSeconds(getIdleSeconds(startAt));
    const interval = setInterval(() => {
      setIdleSeconds(getIdleSeconds(startAt));
    }, 1000);
    return () => clearInterval(interval);
  }, [idleSessionStartedAt, parsedStatus, screen, webrtcIdleTime]);

  const statusMeta = useMemo(() => {
    if (screen === "ringing") return { text: "RINGING", dotClass: "ring" };
    if (screen === "oncall") return { text: "ON CALL", dotClass: "busy" };
    if (screen === "conference") return { text: "CONF", dotClass: "busy" };
    return { text: "READY", dotClass: "" };
  }, [screen]);

  const fetchUserData = async () => {
    try {
      const user = JSON.parse(await AsyncStorage.getItem("user"));
      const telephonyProfile = user?.agentData?.agentTelephony?.profile
      if (user) {
        setUserData(user);
      }
    } catch (error) {
      console.log("Error getting logged in user data", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  useEffect(() => {
    if (!userData?.id) return;
    useCallStore.getState().setCallCreatedBy(userData.id);
  }, [userData]);

  useEffect(() => {
    if (!completedCallToPersist) return;

    const digitsOnly = (value) => String(value || "").replace(/\D/g, "");

    const createdBy = completedCallToPersist.created_by || userData?.id || null;
    const callerNumber = digitsOnly(completedCallToPersist.caller_number);

    if (!createdBy || !callerNumber) {
      useCallStore.getState().clearCompletedCallToPersist();
      return;
    }

    let cleanedNumber = callerNumber?.toString() || "";
    if (cleanedNumber?.startsWith("91") && cleanedNumber?.length > 10) {
      cleanedNumber = cleanedNumber.slice(2);
    }

    if (cleanedNumber?.length > 10) {
      cleanedNumber = cleanedNumber.slice(-10);
    }

    const payload = {
      did: completedCallToPersist.did || null,
      caller_number: cleanedNumber,
      answer_status: completedCallToPersist.answer_status || null,
      end_time: completedCallToPersist.end_time || null,
      patch_duration: completedCallToPersist.patch_duration ?? null,
      billing_duration: completedCallToPersist.billing_duration ?? null,
      dtmf: completedCallToPersist.dtmf || null,
      dnd: completedCallToPersist.dnd ?? null,
      call_sid: completedCallToPersist.call_sid || null,
      start_time: completedCallToPersist.start_time || null,
      pulses: completedCallToPersist.pulses ?? null,
      hangup_cause: completedCallToPersist.hangup_cause || null,
      trunk: completedCallToPersist.trunk || null,
      callee_number: completedCallToPersist.callee_number || null,
      bridge_time: completedCallToPersist.bridge_time || null,
      bridge_ring_duration: completedCallToPersist.bridge_ring_duration ?? null,
      recording_file: completedCallToPersist.recording_file || null,
      recording_uploaded: completedCallToPersist.recording_uploaded ?? false,
      caller_profile: completedCallToPersist.caller_profile || null,
      category: completedCallToPersist.category || "cti",
      created_by: createdBy,
    };

    postApiCall(API_CALLS_CREATE, payload)
      .catch((error) => {
        console.error("Failed to save call record", error);
      })
      .finally(() => {
        useCallStore.getState().clearCompletedCallToPersist();
      });
    if (!userData?.agentData?.id) {
      console.log("No agent ID found in user data, skipping channel licence update");
      return;
    }
    // postApiCall(API_CALL_CENTER_UPDATE_CHANNEL_LICENCE, { agent_id: userData?.agentData?.id })
    //   .catch((error) => {
    //     console.error("Failed to update channel licence", error);
    //   });
  }, [completedCallToPersist, userData]);

  useEffect(() => {
    if (!completedCallToPersist) return;

    const answerStatus = completedCallToPersist.answer_status || "";
    if (answerStatus !== "answered") return;

    const callSid = completedCallToPersist.call_sid || null;
    if (callSid && callSid === dispositionOpenedForCallSid) return;

    const campaignData = activeCampaignFromSip;
    if (!campaignData) return;

    const dispositionForm =
      campaignData?.dispositionForm ||
      campaignData?.disposition_form ||
      campaignData?.disposition_form_details ||
      campaignData?.voice_campaign_disposition_form_details ||
      campaignData?.voice_campaigns_disposition_form_details ||
      null;

    const dispositionFormId = 
      campaignData?.disposition_form_id || 
      dispositionForm?.id || 
      null;

    const rawFields = dispositionForm?.fields;
    const fields = Array.isArray(rawFields)
      ? rawFields
      : typeof rawFields === "string"
        ? (() => {
            try {
              const parsed = JSON.parse(rawFields);
              return Array.isArray(parsed) ? parsed : [];
            } catch {
              return [];
            }
          })()
        : [];

    const dispositionCallerNumber =
      completedCallToPersist?.caller_number || completedCallToPersist?.callerNumber || callerNumber || null;

    const initial = {};
    if (!fields.length) {
      initial.first_name = String(sipLeadData?.first_name || "");
      initial.last_name = String(sipLeadData?.last_name || "");
      initial.contact_number = dispositionCallerNumber ? String(dispositionCallerNumber) : "";
      initial.remarks_status = [];
    } else {
      fields.forEach((f) => {
        const key = String(f?.field_name || "").trim();
        if (!key) return;
        let val = f?.field_default;
        if (val === null || val === undefined) val = "";
        if (f?.field_type === "Date" && val) {
          const d = new Date(val);
          if (!Number.isNaN(d.getTime())) {
            const yyyy = String(d.getFullYear());
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const dd = String(d.getDate()).padStart(2, "0");
            val = `${yyyy}-${mm}-${dd}`;
          }
        }
        initial[key] = String(val);
      });
    }

    setDispositionErrors({});
    setDispositionValues(initial);

    setDispositionMeta({
      campaign_id: String(campaignData?.campaign_id || campaignData?.id || sipCampaignId || ""),
      agent_id: String(loggedUserId || ""),
      disposition_form_id: dispositionFormId ? String(dispositionFormId) : null,
      dispositionForm: dispositionForm || { name: "Basic" },
      fields,
      call_sid: callSid,
      campaign_name: String(campaignData?.campaign_name || ""),
      callerNumber: dispositionCallerNumber,
    });
    setDispositionOpenedForCallSid(callSid || "no-sid");
    setManualScreen("disposition");
  }, [
    activeCampaignFromSip,
    callerNumber,
    completedCallToPersist,
    dispositionOpenedForCallSid,
    loggedUserId,
    sipCampaignId,
    sipLeadData,
  ]);

  const validateDisposition = useCallback(() => {
    const meta = dispositionMeta;
    const fields = meta?.fields || [];
    const nextErrors = {};

    if (!fields.length) {
      if (!dispositionValues?.remarks_status || dispositionValues.remarks_status.length === 0) {
        nextErrors.remarks_status = "Required";
      }

      setDispositionErrors(nextErrors);
      return Object.keys(nextErrors).length === 0;
    }

    const getNum = (val) => {
      if (val === null || val === undefined || val === "") return null;
      const n = Number(val);
      return Number.isFinite(n) ? n : null;
    };

    const toNullableNumber = (val) => {
      if (val === null || val === undefined || val === "") return null;
      const n = Number(val);
      return Number.isFinite(n) ? n : null;
    };

    fields.forEach((f) => {
      const name = String(f?.field_name || "").trim();
      if (!name) return;
      const value = dispositionValues?.[name];

      if (f?.is_required && (value === null || value === undefined || String(value).trim() === "")) {
        nextErrors[name] = "Required";
        return;
      }

      if (String(value || "").trim() === "") return;

      if (f?.field_type === "Integer" || f?.field_type === "Float") {
        const n = getNum(value);
        if (n === null) {
          nextErrors[name] = "Invalid number";
          return;
        }
        if (f?.field_type === "Integer" && !Number.isInteger(n)) {
          nextErrors[name] = "Must be an integer";
          return;
        }
        const minN = toNullableNumber(f?.field_min);
        const maxN = toNullableNumber(f?.field_max);
        if (typeof minN === "number" && n < minN) {
          nextErrors[name] = `Min ${minN}`;
          return;
        }
        if (typeof maxN === "number" && n > maxN) {
          nextErrors[name] = `Max ${maxN}`;
          return;
        }
      }

      if (f?.field_type === "Date") {
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) {
          nextErrors[name] = "Invalid date";
          return;
        }
        if (f?.field_min) {
          const minD = new Date(f.field_min);
          if (!Number.isNaN(minD.getTime()) && d.getTime() < minD.getTime()) {
            nextErrors[name] = `Min ${String(f.field_min)}`;
            return;
          }
        }
        if (f?.field_max) {
          const maxD = new Date(f.field_max);
          if (!Number.isNaN(maxD.getTime()) && d.getTime() > maxD.getTime()) {
            nextErrors[name] = `Max ${String(f.field_max)}`;
            return;
          }
        }
      }
    });

    setDispositionErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  }, [dispositionMeta, dispositionValues]);

  const submitDisposition = useCallback(async () => {
    if (dispositionSubmitting) return;
    if (!validateDisposition()) return;

    if (!dispositionMeta?.campaign_id || !dispositionMeta?.agent_id) {
      toast.error("Missing campaign/agent identifiers");
      return;
    }

    setDispositionSubmitting(true);
    try {
      const fields = dispositionMeta?.fields || [];
      let typedData = {};
      if (!fields.length) {
        typedData = {
          first_name: dispositionValues?.first_name || "",
          last_name: dispositionValues?.last_name || "",
          contact_number: dispositionValues?.contact_number || "",
          remarks_status: dispositionValues?.remarks_status || [],
        };
      } else {
      fields.forEach((f) => {
        const name = String(f?.field_name || "").trim();
        if (!name) return;
        const rawVal = dispositionValues?.[name];
        if (rawVal === null || rawVal === undefined || String(rawVal).trim() === "") return;
        const type = f?.field_type || "String";
        if (type === "Integer") typedData[name] = parseInt(rawVal, 10);
        else if (type === "Float") typedData[name] = Number(rawVal);
        else typedData[name] = String(rawVal);
      });
      }

      const payload = {
        campaign_id: dispositionMeta.campaign_id,
        agent_id: dispositionMeta.agent_id,
        disposition_form_id: dispositionMeta.disposition_form_id || null,
        data: typedData,
      };

      await postApiCall(API_DISPOSITION_FORM_DATA_CREATE, payload);
      toast.success("Disposition saved");
      setDispositionMeta(null);
      setDispositionValues({});
      setDispositionErrors({});
      setManualScreen(null);
    } catch (err) {
      console.error("Failed to submit disposition", err);
      toast.error(JSON.stringify(err) || "Failed to submit disposition");
    } finally {
      setDispositionSubmitting(false);
    }
  }, [dispositionMeta, dispositionSubmitting, dispositionValues, validateDisposition]);

  useEffect(() => {
    getApiCall(`${API_BREAK_LIST}?status=1`, {})
      .then(onListSuccess)
      .catch(onError);
  }, []);

  function onError(err) {
    console.log(err);
  }

  function onListSuccess(resp) {
    setBreaksData(resp);
  }

  useEffect(() => {
      const fetchUserDataAndCampaigns = async () => {
        const rawUser = await AsyncStorage.getItem("user");
    
        if (!rawUser) {
          console.error("User data not found in AsyncStorage");
          return;
        }
    
        let user;
        try {
          user = JSON.parse(rawUser);
        } catch (e) {
          console.error("Invalid JSON in AsyncStorage user:", e);
          return;
        }

        if (user) {
          setUserData(user);
        }

        const telephonyProfile = user?.agentData?.agentTelephony?.profile
        if (telephonyProfile) {
          const isActive = telephonyProfile.some(profile => 
            (profile.type === "Soft Phone" || profile.type === "WEBRTC") &&
            profile.active_profile === true
          );

          setTelephonyProfileActive(isActive);
        }
    
        const role = user?.role;
        setLoggedUserRole(role);
    
        if (role === USER_ROLES.CALL_CENTRE_AGENT) {
          const id = user?.agentData?.id;
          setLoggedUserId(id);
          fetchCampaigns(role, id);
          const { start_date, end_date } = callLogFilterRef.current;
          fetchAgentCallsData(role, id, start_date, end_date);
        }
      };
    
      fetchUserDataAndCampaigns();
    }, []);

    const fetchCampaigns = async (role, agentId = null) => {
      setLoading(true);
      let url = API_AGENT_DASHBOARD_CAMPAIGNS;
    
      if (role === USER_ROLES.CALL_CENTRE_AGENT && agentId) {
        url += `?agent_id=${agentId}`;
      }
      try {
        const res = await getApiCall(url, {}, false);
        onCampaignListSuccess(res);
      } catch (error) {
        onError(error);
      } finally {
        setLoading(false);
      }
    };

    const fetchAnnouncements = async () => {
      try {
        const resp = await getApiCall(API_AGENT_ANNOUNCEMENT_LIST, {}, false);
        setAnnouncements(Array.isArray(resp) ? resp : []);
      } catch (error) {
        onError(error);
      }
    };
    
    function onCampaignListSuccess(resp) {
      setCampaigns(resp);
    }

    const callLogFilterRef = useRef({
      start_date: new Date().toISOString().split("T")[0],
      end_date:   new Date().toISOString().split("T")[0],
    });

    const fetchAgentCallsData = async (role, agentId = null, startDate = null, endDate = null) => {
      setLoading(true);
      let url = API_AGENT_DASHBOARD_CALLS;

      if (role === USER_ROLES.CALL_CENTRE_AGENT && agentId) {
        url = url.replace(":id", agentId);
      }

      const params = {};
      if (startDate) params.start_date = startDate;
      if (endDate)   params.end_date   = endDate;

      try {
        const res = await getApiCall(url, params, false);
        onAgentCallsSuccess(res);
      } catch (error) {
        onError(error);
      } finally {
        setLoading(false);
      }
    };

    const handleCallLogFilter = useCallback((start_date, end_date) => {
      callLogFilterRef.current = { start_date, end_date };
      fetchAgentCallsData(loggedUserRole, loggedUserId, start_date, end_date);
    }, [loggedUserRole, loggedUserId]);

    function onAgentCallsSuccess(resp) {
      setAgentCallsData(resp);
    }

    useEffect(() => {
      if (!loggedUserRole || !loggedUserId || (loggedUserRole !== USER_ROLES.CALL_CENTRE_AGENT)) return;
      let isMounted = true;
      let timeoutId;
      const poll = async () => {
        if (!isMounted) return;
        const { start_date, end_date } = callLogFilterRef.current;
        await fetchAgentCallsData(loggedUserRole, loggedUserId, start_date, end_date);
        await fetchCampaigns(loggedUserRole, loggedUserId);
        timeoutId = setTimeout(poll, 6000);
      };
      poll();
      return () => {
        isMounted = false;
        if (timeoutId) clearTimeout(timeoutId);
      };
    }, [loggedUserRole, loggedUserId]);

    useEffect(() => {
      if (!loggedUserRole || (loggedUserRole !== USER_ROLES.CALL_CENTRE_AGENT)) return;
      let isMounted = true;
      let timeoutId;
      const poll = async () => {
        if (!isMounted) return;
        if (screen === "idle") {
          await fetchAnnouncements();
        }
        timeoutId = setTimeout(poll, 10000);
      };
      poll();
      return () => {
        isMounted = false;
        if (timeoutId) clearTimeout(timeoutId);
      };
    }, [loggedUserRole, screen]);

    useEffect(() => {
      if (telephonyProfileActive) {
        const timeout = setTimeout(() => {
          try {
            require("../../components/partials/dashboard/CallIcon/demo-1");
          } catch (err) {
            console.error("Error loading demo file:", err);
          }
        }, 1000);
        return () => clearTimeout(timeout);
      }
    }, [telephonyProfileActive]);

  const sendAgentIdleStats = useCallback(
    async (toOverride) => {
      if (!parsedStatus?.success) return;
      if (!loggedUserId) return;

      const {
        idleSessionStartedAt,
        webrtcPhoneStartTime,
        incomingReceivedAt,
        idleStatsSentForIncomingAt,
      } = useCallStore.getState();

      if (incomingReceivedAt && idleStatsSentForIncomingAt === incomingReceivedAt) {
        return;
      }

      const from = idleSessionStartedAt || webrtcPhoneStartTime || idleStartedAt;
      const to = toOverride || incomingReceivedAt || new Date().toISOString();

      if (!from) return;

      const payload = {
        from,
        to,
        agent_id: loggedUserId,
      };

      try {
        await postApiCall(API_AGENT_IDLE_STATS, payload);
        if (incomingReceivedAt) {
          useCallStore.getState().markIdleStatsSentForIncomingAt(incomingReceivedAt);
        }
      } catch (error) {
        console.error("Failed to save agent idle stats", error);
      }
    },
    [idleStartedAt, loggedUserId, parsedStatus],
  );

  const handlePlaceCall = useCallback(async () => {
    // await sendAgentIdleStats();
    // setScreen("oncall");
  }, [sendAgentIdleStats]);

  const handleRinging = useCallback((value) => {
    if (value) {
      setDialNum(value);
    }
    // setScreen("ringing");
  }, []);

  const handleAcceptCall = useCallback(async () => {
    const store = useCallStore.getState();
    const session = store.session;

    if (!session) {
      console.error("No session found");
      return;
    }

    if (store.isAnswering) return;

    // Important: SIP accept/hangup is handled by `demo-1.js` DOM bindings (SimpleUser.answer()).
    // Calling `session.accept()` here causes a double-accept race and throws:
    // "sip.Invitation | Invalid session state Establishing".
    store.setAnswering(true);
  }, []);

  const handleRejectCall = useCallback(() => {
    const store = useCallStore.getState();
    const session = store.session;

    if (!session) {
      console.log("No session to reject");
      return;
    }

    // Decline is handled by `demo-1.js` (SimpleUser.hangup()) via the "hangup" DOM bindings.
    // Keep local meta update only.
    try {
      store.markActiveCallDeclinedByAgent?.();
    } catch (err) {
      console.error("Error marking call declined:", err);
    } finally {
      store.setAnswering(false);
    }
  }, []);

  const handleEndCall = useCallback(() => {
    const store = useCallStore.getState();
    const session = store.session;

    if (!session) {
      console.log("No session to end");
      return;
    }

    // Hangup is handled by `demo-1.js` (SimpleUser.hangup()) via the "hangup" DOM bindings.
    store.setAnswering(false);
  }, []);

  useEffect(() => {
    // When an incoming call gets connected, send idle stats once per call.
    if (callState !== "oncall") return;

    const receivedAt = useCallStore.getState().incomingReceivedAt;
    sendAgentIdleStats(receivedAt || new Date().toISOString());

    // Ensure ringing UI exits "Answering..." even if any other code path forgets.
    useCallStore.getState().setAnswering(false);
  }, [callState, sendAgentIdleStats]);

  return (
    <>
      <div className="cti-app-shell" data-theme={theme}>
        <NavBar
          screen={screen}
          onScreenChange={setManualScreen}
          statusMeta={statusMeta}
          theme={theme}
          userData={userData}
          agentCallsData={agentCallsData}
          showDispositionTab={Boolean(dispositionMeta)}
          onToggleTheme={() =>
            setTheme((value) => (value === "light" ? "dark" : "light"))
          }
        />

        {/* {screen === "idle" && ( */}
          <div style={{
            opacity: screen === "idle" ? 1 : 0,
            visibility: screen === "idle" ? "visible" : "hidden",
            display: screen === "idle" ? "block" : "none",
            pointerEvents: screen === "idle" ? "auto" : "none",
            transition: "opacity 0.3s ease"
          }}>
          <IdleScreen
            idleSeconds={idleSeconds}
            idleStatus={idleStatus}
            activeTab={activeTab}
            dialNum={dialNum}
            breakEndTime={breakEndTime}
            countdown={countdown}
            breaksData={breaksData}
            selectedBreakId={selectedBreakId}
            onDial={(value) => setDialNum((current) => current + value)}
            onDialBack={() =>
              setDialNum((current) => {
                const lockedPrefix = dialerLockedPrefixRef.current;
                if (lockedPrefix && current.length <= lockedPrefix.length) return current;
                return current.slice(0, -1);
              })
            }
            onTabChange={setActiveTab}
            onStatusChange={setIdleStatus}
            onPlaceCall={handlePlaceCall}
            onRinging={handleRinging}
            onSetBreakClick={() => setShowBreakModal(true)}
            onRemoveBreakClick={() => setShowCancelModal(true)}
            userData={userData}
            campaigns={campaigns}
            theme={theme}
            userStatus={userStatus}
            agentCallsData={agentCallsData}
            loggedUserRole={loggedUserRole}
            loggedUserId={loggedUserId}
            idleFrom={idleSessionStartedAt || webrtcIdleTime}
            announcements={announcements}
            onCallLogFilter={handleCallLogFilter}
          />
          </div>
        {/* )} */}

        {/* {screen === "ringing" && ( */}
          <div style={{
            opacity: screen === "ringing" ? 1 : 0,
            visibility: screen === "ringing" ? "visible" : "hidden",
            pointerEvents: screen === "ringing" ? "auto" : "none",
            display: screen === "ringing" ? "block" : "none",
            transition: "opacity 0.3s ease"
          }}>
          <RingingScreen 
          onAccept={handleAcceptCall}
          agentCallsData={agentCallsData}
          userData={userData}
          onReject={handleRejectCall}/>
          </div>
        {/* )} */}

        {/* {screen === "oncall" && ( */}
          <div style={{
            opacity: (screen === "oncall" || screen === "hold") ? 1 : 0,
            visibility: (screen === "oncall" || screen === "hold") ? "visible" : "hidden",
            pointerEvents: (screen === "oncall" || screen === "hold") ? "auto" : "none",
            display: (screen === "oncall" || screen === "hold") ? "block" : "none",
            transition: "opacity 0.3s ease"
          }}>
          <OnCallScreen
            callSeconds={callSeconds}
            holdOn={holdOn}
            muteOn={muteOn}
            onToggleHold={() => setHoldOn((value) => !value)}
            onToggleMute={() => setMuteOn((value) => !value)}
            onGoConference={() => setManualScreen("conference")}
            // onEndCall={() => setScreen("idle")}
            campaigns={campaigns}
            activeCampaign={activeCampaignFromSip}
            activeCampaignLoading={activeCampaignLoading}
            agentCallsData={agentCallsData}
            screen={screen}
            onReject={handleEndCall}
          />
          </div>
        {/* )} */}

        {/* {screen === "conference" && ( */}
          <div style={{
            opacity: screen === "conference" ? 1 : 0,
            visibility: screen === "conference" ? "visible" : "hidden",
            pointerEvents: screen === "conference" ? "auto" : "none",
            display: screen === "conference" ? "block" : "none",
            transition: "opacity 0.3s ease"
          }}>
          <ConferenceScreen
            confSeconds={confSeconds}
            // onLeave={() => setScreen("oncall")}
            // onEndAll={() => setScreen("idle")}
            agentCallsData={agentCallsData}
          />
          </div>
        {/* )} */}

        {/* {screen === "disposition" && ( */}
          <div style={{
            opacity: screen === "disposition" ? 1 : 0,
            visibility: screen === "disposition" ? "visible" : "hidden",
            pointerEvents: screen === "disposition" ? "auto" : "none",
            display: screen === "disposition" ? "block" : "none",
            transition: "opacity 0.3s ease"
          }}>
          <DispositionScreen
            dispositionMeta={dispositionMeta}
            dispositionValues={dispositionValues}
            setDispositionValues={setDispositionValues}
            dispositionErrors={dispositionErrors}
            setDispositionErrors={setDispositionErrors}
            remarkStatusList={remarkStatusList}
            dispositionSubmitting={dispositionSubmitting}
            onSubmit={submitDisposition}
            onBack={() => setManualScreen(null)}
            userData={userData}
          />
        {/* )} */}
        </div>
      </div>
      {/* Break Selection Modal */}
      <Modal show={showBreakModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Choose Break</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="breakSelect">
            <Form.Label>
              Select a break:
              <span style={{ color: "red", margin: "0 4px" }}>*</span>
            </Form.Label>
            <Form.Select
              value={selectedBreakId}
              onChange={(e) => setSelectedBreakId(e.target.value)}
            >
              <option value="">Select Break</option>
              {breaksData.map((brk) => (
                <option key={brk.id} value={brk.id}>
                  {brk.title} - ({brk.duration} Mins)
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            style={{ marginRight: "20px", backgroundColor: "grey" }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            style={{ backgroundColor: "#1789e5ff" }}
            onClick={() => {
              startBreak(selectedBreakId);
              handleClose();
            }}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Cancel Break Modal */}
      <Modal
        show={showCancelModal}
        onHide={() => setShowCancelModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Cancel Break</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to cancel the break?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowCancelModal(false)}
            style={{ marginRight: "20px", backgroundColor: "grey" }}
          >
            No
          </Button>
          <Button
            variant="danger"
              onClick={() => {
                const user = JSON.parse(localStorage.getItem("user"));
                stopBreak(user?.id);
                setShowCancelModal(false)
              }}
              style={{ backgroundColor: "#1789e5ff" }}
          >
            Yes, Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <audio id="remoteAudio" autoPlay playsInline></audio>
      <audio ref={hangupAudioRef} src={hangupAudio} preload="auto" id="hangupAudio"/>
    </>
  );
}

export default CTI;
